import { defineNuxtRouteMiddleware } from '#app'
import { isEmpty } from 'lodash'
import { useAppStore } from '~/base/stores/app'
import { useAppointmentStore } from '~/terminierungsportal/stores/appointment'
import { useDataLayerMixin } from '#imports'

export default defineNuxtRouteMiddleware((to) => {
  const appStore = useAppStore()
  const appointmentStore = useAppointmentStore()
  const { eventPageLoad } = useDataLayerMixin()
  if (to.meta?.pageName) {
    eventPageLoad(
      to,
      appStore.environment,
      !isEmpty(appointmentStore.appointmentId)
        ? appointmentStore.appointmentId
        : (to.params.appointmentId as string)
    )
  }
})
